<p class="full-text-op">{{'iiifviewer.fullscreen.notice' | translate}}</p>
<p *ngIf="!isViewerAvailable" id="viewer-message">{{viewerMessage}}</p>
<ng-container *ngVar="(iframeViewerUrl | async) as iframeUrl">
  <iframe title="Mirador Viewer" allowtransparency="true" *ngIf="isViewerAvailable && iframeUrl" [src]="(iframeUrl) | dsSafeUrl" id="mirador-viewer"></iframe>
</ng-container>

